<script setup>
const props = defineProps({
  message: {
    type: String,
    default: "No results found"
  },
  icon: {
    type: String,
    default: "mdi-playlist-remove"
  },
  color: {
    type: String,
    default: "info"
  },
  actions: {
    type: Array,
    default: () => []
  }
});
</script>

<template>
  <div
      class="pa-6 d-flex flex-column align-center text-center"
      style="background: rgb(var(--v-theme-light)); border:1px solid rgb(var(--v-theme-borderLight)); border-radius:14px;"
  >
    <v-icon :icon="icon" size="32" class="mb-2" :style="{ color: 'rgb(var(--v-theme-textSubtle))' }" />
    <div style="color: rgb(var(--v-theme-textSubtle)); font-size:13.5px;">
      <slot>
        {{ message }}
      </slot>
    </div>
    <div v-if="actions.length" class="d-flex flex-wrap justify-center mt-3" style="gap:8px;">
      <v-btn
          size="small"
          v-for="action in actions"
          :key="action.title"
          :color="action.color"
          :loading="action.loading"
          @click="action.click"
      >
        <v-icon>{{ action.icon }}</v-icon>
        {{ action.title }}
      </v-btn>
    </div>
  </div>
</template>

<style scoped>
</style>
